import type {
  SelectContentProps,
  MultiSelectOption,
} from 'components/ui/Forms';

export function optionsMapper(input: any): SelectContentProps {
  return {
    name: input.label,
    value: input.value,
  };
}

export function multiSelectorOptionsMapper(
  input: any
): MultiSelectOption {
  return {
    label: input.label,
    value:
      typeof input.value === 'number' ? input.value.toString() : input.value,
  };
}